var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 2.5C9.08331 2.5 8.33331 3.25 8.33331 4.16667C8.33331 5.08333 9.08331 5.83333 9.99998 5.83333C10.9166 5.83333 11.6666 5.08333 11.6666 4.16667C11.6666 3.25 10.9166 2.5 9.99998 2.5ZM9.99998 14.1667C9.08331 14.1667 8.33331 14.9167 8.33331 15.8333C8.33331 16.75 9.08331 17.5 9.99998 17.5C10.9166 17.5 11.6666 16.75 11.6666 15.8333C11.6666 14.9167 10.9166 14.1667 9.99998 14.1667ZM9.99998 8.33333C9.08331 8.33333 8.33331 9.08333 8.33331 10C8.33331 10.9167 9.08331 11.6667 9.99998 11.6667C10.9166 11.6667 11.6666 10.9167 11.6666 10C11.6666 9.08333 10.9166 8.33333 9.99998 8.33333Z",
    fill: "#293855"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.f79d1880b88d86916853f49888a7a494.svg";
export { ForwardRef as ReactComponent };